/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotButton = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'BUTTON',
]);

export default [
  ...[
    getFilterWithCol(['FieldText', {
      name: 'button_label',
      label: null,
      prefix: 'Label:',
      i18nTranslatable: true,
    }], 12),
    getFilterWithCol(['FieldText', {
      name: 'button_link',
      label: null,
      prefix: 'Link:',
    }], 12),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotButton, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
